import React from "react";
import {
    Card,
    CardContent,
    Typography,
    CardHeader,
    CardActionArea,
    LinearProgress,
    Box,
    Tooltip
} from "@mui/material";
import {Link} from "react-router-dom";
import DoughnutChart from "../Charts/DoughnutChart";

import PORTAvatar from "../PORTAvatar";

function ActivitiesCard({data}) {

    if (!data) return (<LinearProgress/>);

    const activities = data;
    let totalCount = 0;
    let dataSet = {};

    // loop through all activities
    if (activities) {
        activities.forEach((activity) => {

            totalCount++;
            let key = activity?.type?.name ?? 'Undefined';

            if (dataSet[key]) {
                dataSet[key] = dataSet[key] + 1;
            } else {
                dataSet[key] = 1;
            }
        })
    }

    const dataSetLabel = '# of activities';
    const dataSetLabels = Object.keys(dataSet);
    const dataSetValues = Object.values(dataSet);

    return (
        <Card className="card">
            <CardActionArea component={Link} to={'/portfolio/activities'} centerRipple={true}>
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View all activities" arrow>
                            <PORTAvatar type={'activity'}/>
                        </Tooltip>
                    }
                    title={<Typography component="h2" className="card-header-title">Activities</Typography>}
                    subheader={
                        <Typography component="span" className="card-header-subtitle">
                            Your activities
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                {totalCount > 0 && (
                    <Box className="doughnut">
                        <DoughnutChart label={dataSetLabel} labels={dataSetLabels} values={dataSetValues}/>
                    </Box>
                )}
                <Box className="card-content">
                    <Typography variant="body1" className="text"
                                sx={{textAlign: 'right'}}>{totalCount} activities </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default ActivitiesCard;
